import Index from '../../pages/snail/million/index/index'
import smspage from '../../pages/snail/million/smspage/index.vue'
import test from '../../pages/snail/million/test/index.vue'

const base = 'million'

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/smspage*`,
    name: `${base}-smspage`,
    component: smspage
  },
  {
    path: `/${base}/test`,
    name: `${base}-test`,
    component: test
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/snail/million.js